// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import Program from './Program'
import ProgramsFilters from './ProgramsFilters'

// Redux:
import { getAccountLikesData, setHasScrolledToProgramsPage } from 'actions/site'

class Programs extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		dispatch( getAccountLikesData() )
	}

	componentDidUpdate() {
		const { dispatch, hasScrolledToProgramsPage, programsPageScrollOffset } = this.props

		if ( ! hasScrolledToProgramsPage && this.refPrograms ) {
			zenscroll.setup( null, programsPageScrollOffset )
			zenscroll.to( this.refPrograms )

			dispatch( setHasScrolledToProgramsPage() )
		}
	}

	render() {
		const { loggedIn } = this.props
		const { categoriesById, programsById, filteredProgramIds, accountData } = this.props
		let markupLiked = [],
			markup = [],
			keysLiked = [],
			keys = []

		if ( programsById && Object.keys( programsById ).length ) {
			Object.keys( programsById ).forEach( key => {
				if ( filteredProgramIds.indexOf( key ) === -1 ) {
					return
				}

				let item = programsById[ key ]

				if ( accountData && accountData.likes_series && accountData.likes_series[ item.slug ] ) {
					keysLiked.push( key )
				} else {
					keys.push( key )
				}
			} )

			keysLiked.forEach( key => {
				let item = programsById[ key ]

				markupLiked.push(
					<Program
						key={ item.slug }
						data={ item }
						isLiked={ true }
					/>
				)
			} )

			keys.forEach( key => {
				let item = programsById[ key ]

				markup.push(
					<Program
						key={ item.slug }
						data={ item }
					/>
				)
			} )
		}

		return (
			<div className="programs-wide-section">
				<ProgramsFilters />

				<div className="-tabs" ref={ ( e ) => { this.refPrograms = e } }>
					<NavLink to="/programs/" activeClassName="is-active">Programs</NavLink>
					<NavLink to="/podcasts/" activeClassName="is-active">Podcasts</NavLink>

					{ loggedIn &&
						<NavLink to="/favourites/" activeClassName="is-active">Favourites</NavLink>
					}

					<NavLink to="/schedule/" activeClassName="is-active">Schedule</NavLink>
				</div>

				<div className="programs">
					<div className="-inner">
						{ markupLiked }
						{ markup }
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		programsById: state.programs.byId,
		filteredProgramIds: state.programs.filteredProgramIds,
		categoriesById: state.programs.categoriesById,
		accountData: state.site.accountData,
		loggedIn: state.site.loggedIn,
		hasScrolledToProgramsPage: state.site.hasScrolledToProgramsPage,
		programsPageScrollOffset: state.site.programsPageScrollOffset
	}
}

export default connect( mapStateToProps )( Programs )
